import React from 'react'
import Button from 'react-bootstrap/Button';


export const Btn = () => {
  return (
    <div>
        <Button variant="primary">VER PRODUCTO</Button>
    </div>
  )
}
